import React from 'react'
import ScrollUpButton from 'react-scroll-up-button'

const TermsOfUsePage = () => (
  <div className='terms'>
    <h2>利用規約</h2>
    <ul className="breadcrumb">
      <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
        <a href="/" itemProp="url">
          <span itemProp="title"><i className="fas fa-home"></i> ホーム</span>
        </a>
      </li>
      <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
        <span itemProp="title"> <i className="fas fa-caret-right"></i> 利用規約</span>
      </li>
    </ul>
    <div className='summary'>
      この規約は、お客様が、株式会社IT-ai（以下「当社」）が提供する「駄菓子屋に住むシェアハウス」サービス（以下「本サービス」）
      をご利用頂く際の取扱いにつき定めるものです。本規約に同意した上で本サービスをご利用ください。
    </div>
    <div className='terms-item'>
      <h3>第１条（定義）</h3>
      <div className='description'>
      　本規約上で使用する用語の定義は、次に掲げるとおりとします。
      <ul>
        <li>本サービス	当社が運営するサービス及び関連するサービス</li>
        <li>本サイト	本サービスのコンテンツが掲載されたウェブサイト</li>
        <li>本コンテンツ	本サービス上で提供される文字、静止画、動画、ソフトウェアプログラム、コード等の総称（投稿情報を含む）</li>
      </ul>
      </div>
    </div>
    <div className='terms-item'>
      <h3>第２条（本規約への同意）</h3>
      <div className='description'>
        <ul>
          <li>利用者は、本利用規約に同意頂いた上で、本サービスを利用できるものとします。</li>
          <li>利用者が、本サービスをスマートフォンその他の情報端末にダウンロードし、本規約への同意手続を行った時点で、利用者と当社との間で、本規約の諸規定に従った利用契約が成立するものとします。</li>
          <li>利用者が未成年者である場合には、親権者その他の法定代理人の同意を得たうえで、本サービスをご利用ください。</li>
          <li>未成年者の利用者が、法定代理人の同意がないにもかかわらず同意があると偽りまたは年齢について成年と偽って本サービスを利用した場合、その他行為能力者であることを信じさせるために詐術を用いた場合、本サービスに関する一切の法律行為を取り消すことは出来ません。</li>
          <li>本規約の同意時に未成年であった利用者が成年に達した後に本サービスを利用した場合、当該利用者は本サービスに関する一切の法律行為を追認したものとみなされます。</li>
        </ul>
      </div>
    </div>
    <div className='terms-item'>
      <h3>第３条（規約の変更）</h3>
      <div className='description'>
        <ul>
          <li>当社は、利用者の承諾を得ることなく、いつでも、本規約の内容を改定することができるものとし、利用者はこれを異議なく承諾するものとします。</li>
          <li>当社は、本規約を改定するときは、その内容について当社所定の方法により利用者に通知します。</li>
        </ul>
      </div>
    </div>
    <div className='terms-item'>
      <h3>第４条（アカウントの管理）</h3>
      <div className='description'>
        <ul>
          <li>利用者は、利用に際して登録した情報（以下、「登録情報」といいます。メールアドレスやID・パスワード等を含みます）について、自己の責任の下、任意に登録、管理するものとします。利用者は、これを第三者に利用させ、または貸与、譲渡、名義変更、売買などをしてはならないものとします。</li>
          <li>当社は、登録情報によって本サービスの利用があった場合、利用登録をおこなった本人が利用したものと扱うことができ、当該利用によって生じた結果ならびにそれに伴う一切の責任については、利用登録を行った本人に帰属するものとします。</li>
        </ul>
      </div>
    </div>
    <div className='terms-item'>
      <h3>第５条（個人情報等の取り扱い）</h3>
      <div className='description'>
        個人情報及び利用者情報については、当社が別途定める「本サービス プライバシーポリシー」に則り、適正に取り扱うこととします。<br/>
      </div>
    </div>
    <div className='terms-item'>
      <h3>第６条（禁止行為）</h3>
      <div className='description'>
        本サービスの利用に際し、当社は、利用者に対し、次に掲げる行為を禁止します。当社において、利用者が禁止事項に違反したと認めた場合、利用の一時停止、退会処分その他当社が必要と判断した措置を取ることができます。
        <ul>
          <li>当社または第三者の知的財産権を侵害する行為</li>
          <li>当社または第三者の名誉・信用を毀損または不当に差別もしくは誹謗中傷する行為</li>
          <li>上記の他、当社が不適切と判断する行為</li>
        </ul>
      </div>
    </div>
    <div className='terms-item'>
      <h3>第７条（免責）</h3>
      <div className='description'>
        <ul>
          <li>当社は、本サービスの内容変更、中断、終了によって生じたいかなる損害についても、一切責任を負いません。</li>
          <li>当社は、利用者の本サービスの利用環境について一切関与せず、また一切の責任を負いません。</li>
          <li>第１項乃至前項の規定は、当社に故意または重過失が存する場合又は契約書が消費者契約法上の消費者に該当する場合には適用しません。</li>
          <li>前項が適用される場合であっても、当社は、過失（重過失を除きます。）による行為によって利用者に生じた損害のうち、特別な事情から生じた損害については、一切賠償する責任を負わないものとします。</li>
          <li>本サービスの利用に関し当社が損害賠償責任を負う場合、当該損害が発生した月に利用者から受領した利用額を限度として賠償責任を負うものとします。</li>
        </ul>
      </div>
    </div>
    <div className='terms-item'>
      <h3>第８条（当社への連絡方法）</h3>
      <div className='description'>
        本サービスに関する利用者の当社へのご連絡・お問い合わせは、本サービスまたは当社が運営するwebサイト内の適宜の場所に設置するお問い合わせフォームからの送信または当社が別途指定する方法により行うものとします。<br/>
      </div>
    </div>
    <div className='terms-item'>
      <h3>第９条（準拠法、管轄裁判所）</h3>
      <div className='description'>
        <ul>
          <li>本規約の有効性，解釈及び履行については，日本法に準拠し，日本法に従って解釈されるものとする。</li>
          <li>当社と利用者等との間での論議・訴訟その他一切の紛争については、訴額に応じて、東京簡易裁判所又は東京地方裁判所を専属的合意管轄裁判所とします。</li>
        </ul>
      </div>
    </div>
    2020年1月30日 施行
    <ScrollUpButton style={{width: 30, height: 30}} />
  </div>
)

export default TermsOfUsePage


// WEBPACK FOOTER //
// ./src/TermsOfUsePage.js